import { render, staticRenderFns } from "./IconBilling.vue?vue&type=template&id=b196b5b6&"
import script from "./IconBilling.vue?vue&type=script&lang=js&"
export * from "./IconBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b196b5b6')) {
      api.createRecord('b196b5b6', component.options)
    } else {
      api.reload('b196b5b6', component.options)
    }
    module.hot.accept("./IconBilling.vue?vue&type=template&id=b196b5b6&", function () {
      api.rerender('b196b5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconBilling.vue"
export default component.exports